import { createContext } from 'react';

export const CollaborationModifiersContext = createContext({});

export default CollaborationModifiersContext;
